import { ButtonSize, ButtonVariants } from '@anm/components/buttons/Button';
import Dialog from '@anm/components/modals/Dialog';
import Confirm from '@anm/components/notification/Confirm';
import { FC } from 'react';
import usePaidThemeAndLayout from '../hooks/usePaidThemeAndLayout';

export type LeaveTabAlertAlertProps = {
  isPending: boolean;
  onClose(): void;
  onCancel(): void;
  onConfirm(): void;
};

const LeaveTabAlert: FC<LeaveTabAlertAlertProps> = ({ isPending, onClose, onCancel, onConfirm }) => {
  const { shouldUpgrade } = usePaidThemeAndLayout();

  if (shouldUpgrade) {
    onCancel();
    return null;
  }

  const confirmParams = {
    isPending,
    text: 'Save',
    size: 'upper-medium' as ButtonSize,
    variant: 'light-blue' as ButtonVariants
  };

  const discardParams = {
    isPending: false,
    text: `Discard`,
    size: 'upper-medium' as ButtonSize,
    variant: 'blue-heavy-border' as ButtonVariants
  };

  return (
    <Dialog onModalClose={onClose} onSubmit={onConfirm}>
      <Confirm
        title="Save changes?"
        titleSize="medium"
        buttonLeft={discardParams}
        buttonRight={confirmParams}
        onLeftButtonClick={onCancel}
        onRightButtonClick={onConfirm}
      >
        {`Your changes will be lost if you don't <br/> save them.`}
      </Confirm>
    </Dialog>
  );
};
export default LeaveTabAlert;
